import "./Auth.css";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../Logo";
import ChangeUsername from "../../ChangeUsername/ChangeUsername";
import { createUserWithEmailAndPassword, deleteUser } from "firebase/auth";
import { useRef, useState } from "react";
import { getAuth } from "firebase/auth";
import { app } from "../../../functions/firebaseInit";
import { useNavigate } from "react-router-dom";
import { initializeApp } from "firebase/app";
import { doc, getFirestore, setDoc } from "firebase/firestore";

export default function SignUp() {
    const credentials = useRef(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [displayName, setDisplayName] = useState("");
    const [status, setStatus] = useState(false);
    
    const fbApp = initializeApp(app);
    const auth = getAuth(fbApp);
    const firestore = getFirestore(fbApp);
    const navigate = useNavigate();
    const location = useLocation();

    const createUser = () => {
        const email = credentials.current[0].value;
        const password = credentials.current[1].value;
        const confirmPassword = credentials.current[2].value;

        setErrorMessage("");

        //console.log(email, password, confirmPassword);
        if (password !== confirmPassword) {
            setErrorMessage("Passwords don't match");
        } else {
            console.log(displayName.valid);
            if (status) {
                createUserWithEmailAndPassword(auth, email, password)
                    .then((user) => {
                        console.log(user.user.uid);
                        try {
                            setDoc(doc(firestore, "users", user.user.uid), { cups: [], displayName: displayName, displayNameLower: displayName.toLowerCase() });
                        } catch (e) {
                            alert(e.message);
                            // delete user if firestore doc can't be created
                            deleteUser(user.user);
                        }
                        navigate("/", { replace: true, state: { yourCup: location.state?.yourCup } });
                    })
                    .catch((error) => setErrorMessage(error.message));
            } else {
                setErrorMessage("Username not validated")
            }
        }
    }

    return <div id="auth-container">
        <div id="form-title">
            <Logo />
            <h1>Sign up</h1>
        </div>

        <div className="auth-form">
            <p className="auth-label">Username</p>
            <p className="auth-note">(This can be changed later)</p>
            <ChangeUsername
                displayName={displayName}
                changeName={setDisplayName}
                changeStatus={setStatus}
                uid={null}
                showChangeButton={false}
            />
        </div>
        <form className="auth-form" onSubmit={(e) => { e.preventDefault(); createUser(); }} ref={credentials}>

            <h3 id="auth-error">{errorMessage}</h3>

            <label className="auth-label" htmlFor="email">Email</label>
            <input id="email" placeholder="Enter email" className="auth-input" autoComplete="email" />

            <label className="auth-label" htmlFor="password">Password</label>
            <input id="password" placeholder="Enter password" className="auth-input" type="password" autoComplete="new-password" />

            <label className="auth-label" htmlFor="confirm-password">Confirm password</label>
            <input id="confirm-password" placeholder="Confirm password" className="auth-input" type="password" autoComplete="new-password" />

            <input type="submit" value="Sign Up" className="auth-confirm" />

        </form>

        <Link onClick={() => navigate(-1)} replace>Have an account already? Sign in</Link>
    </div>
}